export default __webpack_public_path__ + "static/media/logo_stacked.9bedc40b.png";